import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#inicio', label: 'Início' },
    { href: '#sobre', label: 'Sobre' },
    { href: '#acoes', label: 'Ações' },
    { href: '#cadastro', label: 'Cadastre-se' },
    { href: '#diretores', label: 'Diretores' },
    { href: '#contato', label: 'Contato' },
  ];

  const handleClick = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'navbar-scrolled' : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 md:h-24">
          {/* Logo */}
          <a href="#inicio" onClick={(e) => handleClick(e, '#inicio')} className="flex items-center gap-3" data-testid="navbar-logo">
            <img
              src="/images/logos/sindpesca-semfundo.png"
              alt="SINDPESCA"
              className="h-14 md:h-20 lg:h-24 w-auto"
            />
          </a>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-1 lg:gap-2">
            {navLinks.map((link) =>
              link.label === 'Cadastre-se' ? (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleClick(e, link.href)}
                  data-testid="navbar-cadastre-btn"
                  className="ml-2 px-6 py-2 bg-[#1A8C7A] text-white font-semibold rounded-full text-sm
                    hover:bg-[#147363] transition-all duration-300 hover:-translate-y-0.5 shadow-md"
                >
                  {link.label}
                </a>
              ) : (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleClick(e, link.href)}
                  data-testid={`navbar-link-${link.label.toLowerCase()}`}
                  className="px-3 lg:px-4 py-2 text-sm font-medium text-[#1A1A2E] hover:text-[#1A8C7A]
                    transition-colors duration-300 relative group"
                >
                  {link.label}
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-[#E8621A] group-hover:w-3/4 transition-all duration-300" />
                </a>
              )
            )}
          </div>

          {/* Mobile Hamburger */}
          <button
            data-testid="navbar-mobile-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 rounded-lg text-[#1A1A2E] hover:bg-gray-100 transition-colors"
            aria-label="Menu"
          >
            <div className="w-6 h-5 flex flex-col justify-between">
              <span className={`block h-0.5 w-full bg-current transition-transform duration-300 ${mobileOpen ? 'rotate-45 translate-y-2' : ''}`} />
              <span className={`block h-0.5 w-full bg-current transition-opacity duration-300 ${mobileOpen ? 'opacity-0' : ''}`} />
              <span className={`block h-0.5 w-full bg-current transition-transform duration-300 ${mobileOpen ? '-rotate-45 -translate-y-2' : ''}`} />
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        data-testid="navbar-mobile-menu"
        className={`md:hidden overflow-hidden transition-all duration-300 bg-white/95 backdrop-blur-md ${
          mobileOpen ? 'max-h-96 border-t border-gray-100' : 'max-h-0'
        }`}
      >
        <div className="px-4 py-4 space-y-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleClick(e, link.href)}
              data-testid={`mobile-link-${link.label.toLowerCase()}`}
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                link.label === 'Cadastre-se'
                  ? 'bg-[#1A8C7A] text-white text-center mt-2'
                  : 'text-[#1A1A2E] hover:bg-gray-50 hover:text-[#1A8C7A]'
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
}
